import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import "react-checkbox-tree/lib/react-checkbox-tree.css";
import Modal from "../ui/Modal.jsx";
import "../../../styles/analytics/report-modal.scss";

const CoverPageModal = ({ open, onClose, onSubmit, coverPageText = "" }) => {
  const [value, setValue] = useState("");

  useEffect(() => {
    if (open) {
      setValue(coverPageText);
    }
  }, [open]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Cover Page"
      styles={{ width: "520px" }}
      content={
        <Box className="cover-page-modal">
          <textarea value={value} onChange={(e) => setValue(e.target.value)} />
        </Box>
      }
      action={{
        label: "Done",
        onClick: () => {
          onSubmit(value);
          onClose();
        },
      }}
    />
  );
};

export default CoverPageModal;
